import { TripStatus } from '../../models/trip/trip';

/** Trip status → translated label (#5790). */
export function tripStatusLabel(status: TripStatus, t: (key: string, fallback: string) => string): string {
  switch (status) {
    case TripStatus.Draft:
      return t('Trip_Status_Draft', 'Draft');
    case TripStatus.Submitted:
      return t('Trip_Status_Submitted', 'Submitted');
    case TripStatus.Open:
      return t('Trip_Status_Open', 'Open');
    case TripStatus.Rejected:
      return t('Trip_Status_Rejected', 'Rejected');
    case TripStatus.InSettlement:
      return t('Trip_Status_InSettlement', 'In settlement');
    case TripStatus.Closed:
      return t('Trip_Status_Closed', 'Closed');
    default:
      return '';
  }
}

/** Trip status → p-tag severity. */
export function tripStatusSeverity(status: TripStatus): 'success' | 'secondary' | 'warn' | 'info' | 'danger' {
  switch (status) {
    case TripStatus.Open:
      return 'success';
    case TripStatus.Draft:
      return 'warn';
    case TripStatus.Submitted:
    case TripStatus.InSettlement:
      return 'info';
    case TripStatus.Rejected:
      return 'danger';
    default:
      return 'secondary';
  }
}

/** All statuses, in lifecycle order, for filters. */
export const TRIP_STATUSES: TripStatus[] = [
  TripStatus.Draft,
  TripStatus.Submitted,
  TripStatus.Open,
  TripStatus.Rejected,
  TripStatus.InSettlement,
  TripStatus.Closed,
];
